<template>
  <div
    ref="image"
    class="img-container"
    :class="{ active: showImage }"
  >
    <NuxtPicture
      :src="src"
      :alt="alt"
      :img-attrs="{ class: 'object-cover w-full h-full img' }"
      format="webp,png"
    />
  </div>
</template>

<script lang="ts" setup>
import {siteName} from '~~/content/settings/settings.json'
withDefaults(defineProps<{ src?: string, alt?: string, contain?: boolean }>(), { src: '', alt: siteName })
const image = ref<HTMLElement | null>(null)
const targetIsVisible = useElementVisibility(image)
const showImage = ref(false)
watch(targetIsVisible, () => {
  if (targetIsVisible.value)
    showImage.value = true
})
</script>

<style scoped>
.img-container {
  position: relative;
  overflow: hidden;
  -webkit-clip-path: inset(0px 100% 0px 0px);
  clip-path: inset(0px 100% 0px 0px);
  will-change: clip-path;
  transition: -webkit-clip-path 0.6s cubic-bezier(0.785, 0.135, 0.15, 0.86);
  transition: clip-path 0.6s cubic-bezier(0.785, 0.135, 0.15, 0.86);
  transition: clip-path 0.6s cubic-bezier(0.785, 0.135, 0.15, 0.86), -webkit-clip-path 0.6s cubic-bezier(0.785, 0.135, 0.15, 0.86);
}

.img-container.active {
  -webkit-clip-path: inset(0px 0px 0px 0px);
  clip-path: inset(0px 0px 0px 0px);
}

.img-container :deep(.img) {
  position: absolute;
  left: 0px;
  right: 0px;
  top: 0px;
  bottom: 0px;
  background-position: center;
  background-size: cover;
  -webkit-transform: scale(1.5);
  transform: scale(1.5);
  will-change: transform;
  transition: -webkit-transform 0.6s cubic-bezier(0.785, 0.135, 0.15, 0.86);
  transition: transform 0.6s cubic-bezier(0.785, 0.135, 0.15, 0.86);
  transition: transform 0.6s cubic-bezier(0.785, 0.135, 0.15, 0.86), -webkit-transform 0.6s cubic-bezier(0.785, 0.135, 0.15, 0.86);
}

.img-container.active :deep(.img) {
  -webkit-transform: scale(1);
  transform: scale(1);
}
</style>
